export enum MapLayerColor {
  adjuntoFill = '#170055',
  adjuntoOutline = '#261C2C',

  chacraFill = '#7C83FD',
  chacraOutline = '#261C2C',

  dibujosFill = '#3E00FF',
  dibujosOutline = '#261C2C',

  limitantes = '#FF6B6B',

  pendiente = '#FFC93C',

  zonasExclusionFill = '#FB743E',
  zonasExclusionOutline = '#261C2C',
}

export enum MapMode {
  new = 'new',
  view = 'view',
  edit = 'edit',
  notSaved = 'notSaved',
  selectDraw = 'selectDraw'
}

export enum MapAction {
  new = 'new',
  edit = 'edit',
  delete = 'delete'
}

export enum MapTool {
  point = 'point',
  polyline = 'polyline',
  polygon = 'polygon',
  circle = 'circle'
}

export enum GeometryTypes {
  chacra = 'polygon',
  pendiente = 'polyline'
}
